module.exports = __webpack_public_path__ + "img/denmark-diseases-of-the-nervous-system-male.bfa06e9d.png";